import { useEffect } from 'react'

const CHAT_WIDGET_SCRIPT_SRC = 'https://cdn.chat.appfire.app/app/widget-prod/get-chat.min.js'
const CHAT_WIDGET_SERVICE_DESK_ID = '1'

/**
 * Mounts the Appfire Jira Service Management chat widget for the lifetime of the
 * calling component, tearing it down on unmount so it only appears on the page(s)
 * that opt into it.
 *
 * The loader script calls customElements.define('chat-widget', ...) once it runs,
 * and browsers permanently forbid redefining a custom element tag name for the
 * lifetime of the page, so the script itself is only ever injected once. The
 * <chat-widget> element is safe to add/remove on every mount/unmount: custom
 * elements auto-upgrade any matching tag inserted into the DOM after define() runs.
 */
export const useChatWidget = () => {
    useEffect(() => {
        if (!document.querySelector(`script[src="${CHAT_WIDGET_SCRIPT_SRC}"]`)) {
            const script = document.createElement('script')
            script.src = CHAT_WIDGET_SCRIPT_SRC
            document.body.appendChild(script)
        }

        const widget = document.createElement('chat-widget')
        widget.setAttribute('jira-id', process.env.REACT_APP_CHAT_WIDGET_JIRA_ID)
        widget.setAttribute('service-desk-id', CHAT_WIDGET_SERVICE_DESK_ID)
        document.body.appendChild(widget)

        return () => {
            document.body.removeChild(widget)
        }
    }, [])
}
